import { LatLngLocation } from './AemConfigurationTypes';
import { LocationSearchType } from './enums/ClickAndCollectEnums';

export enum StoreFinderType {
  CLICK_AND_COLLECT = 1,
  IN_STORE_FILTER = 2,
  LOCATOR = 3,
  BASKET = 4,
  CHECKOUT = 5,
}

export type LocationSearchResultState = 'INIT' | 'SET' | 'ERROR';

export type LocationSearchResult = {
  location: LatLngLocation;
  locationName: string;
  type: LocationSearchType;
  state?: LocationSearchResultState;
};

export function isLocationSearchResult(value: LocationSearchResult | LatLngLocation): value is LocationSearchResult {
  return (value as LocationSearchResult).type !== undefined;
}

export type LocationOSM = {
  boundingbox: Array<string>;
  category: string;
  display_name: string;
  icon: string;
  importance: number;
  lat: string;
  licence: string;
  lon: string;
  osm_id: number;
  osm_type: string;
  place_id: number;
  place_rank: number;
  type: string;
  address: Record<string, string>;
  error?: Record<string, string>;
};
